import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { OfficeSideSheetButton } from 'src/components/OfficeSidesheet/OfficeSidesheetButton/OfficeSidesheetButton';
import { getDeskLocation } from 'src/store/desks/selectors';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export interface DeskOfficeSidesheetButtonProps {
  small?: boolean;
}

export const DeskOfficeSidesheetButton: FC<DeskOfficeSidesheetButtonProps> = ({
  small,
}) => {
  const dispatch = useAppDispatch();
  const { town, building, loading } = useSelector(getDeskLocation);

  const open = useCallback(() => {
    dispatch(sidesheetActions.open('deskOffice'));
  }, [dispatch]);

  return (
    <OfficeSideSheetButton
      onClick={open}
      town={town}
      building={building}
      disabled={loading}
      small={small}
    />
  );
};
